module.exports = __webpack_public_path__ + "static/media/0.bef7fa42.jpg";